// extracted by mini-css-extract-plugin
export default {"background":"Loading_background__ISmFp","text":"Loading_text__HeAjY"};